const togleNotification = (
    title = 'Error al guardar',
    description = 'Por favor llena tu nombre, apellido y email',
    show = true
) => {
    $('#modalRsvpMessage').text(title);
    if (description === '') {
        $('#modalRsvpCont').addClass('d-none');
    } else {
        $('#modalRsvpCont').removeClass('d-none');
    }
    $('#modalRsvpSubMessage').text(description);
    $('.modal-fix.rsvp').css({
        display: 'flex',
        opacity: show ? '1' : '0',
    });
    $('.modal.rsvp').css('opacity', show ? '1' : '0');
};
async function validateGuestInfo(collection_id) {
    generalLoader.on();
    $('#error-message').slideUp();
    const button = document.getElementById('validate-info');
    button.innerHTML = 'Validando Información';
    button.setAttribute('disabled', true);

    const rsvpName = document.getElementById('rsvp-name');
    const rsvpLname = document.getElementById('rsvp-lname');
    const rsvpEmail = document.getElementById('rsvp-email');
    const rsvpMessage = document.getElementById('rsvp-message');
    const rsvpType = document.getElementById('invitation-type');
    //const collection_id = document.getElementById('collection-id');
    const invitation_id = document.getElementById('invitation-id');
    const infoIsValid = validateInvitationForm(rsvpName.value, rsvpLname.value, rsvpEmail.value, 'error-message');
    if (!infoIsValid) {
        $('#error-message').slideDown();
        button.innerHTML = 'Continuar';
        button.removeAttribute('disabled');
        generalLoader.off();
        return;
    }
    const rsvpData = {
        name: rsvpName.value,
        lastName: rsvpLname.value,
        email: rsvpEmail.value,
        collection_id: collection_id,
    };
    const response = await fetchData(`${productionUrl}${candidateVersion}/collections/inviation/validate`, 'POST', rsvpData);
    console.log('validate:', response);
    if (response.status) {
        const { data } = response;
        const { eventos: events } = data;
        if (data.length === 0) {
            rsvpType.value = 'metaobject';
            invitation_id.value = 'not_found';
            const selects = document.querySelectorAll(`select[metaobjectid]`);
            selects.forEach((select) => {
                for (let i = 1; i <= 6; i++) {
                    const option = document.createElement('option');
                    option.value = i;
                    option.innerHTML = i;
                    select.appendChild(option);
                }
            });
            $('#rsvp-events-container').slideDown();
            $('#rsvp-message-container').slideDown();
            $('#rsvp-send-button-container').slideDown();
            button.style.display = 'none';
            document.getElementById('rsvp-send-button').value = 'Registrarme';
            generalLoader.off();
            return;
        }
        setDataInForm(data, events);
        generalLoader.off();
    }
}
const validateInvitationForm = (name, lastName, email, errorContainerId) => {
    const $errorElement = document.getElementById(errorContainerId);
    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!name || !lastName || !email) {
        $errorElement.innerHTML = 'Por favor, llena todos los campos.';
        return false;
    }
    if (!regexEmail.test(email)) {
        $errorElement.innerHTML = 'El correo electrónico no es válido';
        return false;
    }
    return true;
};
const createOrUpdate = async () => {
    generalLoader.on();
    const rsvpName = document.getElementById('rsvp-name').value;
    const rsvpLname = document.getElementById('rsvp-lname').value;
    const rsvpEmail = document.getElementById('rsvp-email').value;
    const rsvpMessage = document.getElementById('rsvp-message').value;
    const rsvpContainer = document.getElementById('rsvpEvents');
    const selects = rsvpContainer.querySelectorAll('select');
    const collectionId = document.getElementById('collection-id').value;
    const type = document.getElementById('invitation-type').value;
    const invitationId = document.getElementById('invitation-id').value;
    const validateData = validateInvitationForm(rsvpName, rsvpLname, rsvpEmail, 'error-message');
    if (!validateData) {
        $('#error-message').slideDown();
        return;
    }
    const events = [];
    selects.forEach((select) => {
        const event = {
            name: select.getAttribute('name'),
            id: select.getAttribute('metaobjectid'),
            comfirmed: select.value,
        };
        events.push(event);
    });
    const body = {
        collection_id: collectionId,
        guestName: rsvpName,
        guestLastName: rsvpLname,
        guestEmail: rsvpEmail,
        guestMessage: rsvpMessage,
        type: type,
        invitationId: invitationId,
        events: events,
    };
    const url = `${productionUrl}${candidateVersion}/collections/inviation/create-or-update`;
    const response = await fetchData(url, 'POST', body);
    generalLoader.off();
    togleNotification('¡Gracias por confirmar!', 'Tu información ha sido guardada con éxito', true);
    console.log(response);
};
const setDataInForm = (data, invitations) => {
    const button = document.getElementById('validate-info');
    button.innerHTML = 'Validando Información';
    button.setAttribute('disabled', true);

    const rsvpName = document.getElementById('rsvp-name');
    const rsvpLname = document.getElementById('rsvp-lname');
    const rsvpEmail = document.getElementById('rsvp-email');
    const rsvpMessage = document.getElementById('rsvp-message');
    const rsvpType = document.getElementById('invitation-type');
    const collection_id = document.getElementById('collection-id');
    const invitation_id = document.getElementById('invitation-id');
    const selects = document.querySelectorAll(`select[metaobjectid]`);
    let selectsFound = [];
    let message = '';
    invitations.forEach((invitation) => {
        //console.log(invitation);
        const hasEvent = Array.from(selects).find((select) => select.getAttribute('metaobjectid') === invitation.evento);
        //console.log(hasEvent);
        //  selects.forEach((select) => {
        //     const metaobjectid = select.getAttribute('metaobjectid');
        //     if (metaobjectid !== invitation.evento) {
        //         selectsFound[metaobjectid].remove();
        //         //select.closest('.cont').remove();
        //     }
        // }); 
        const $event = document.querySelector(`select[metaobjectid="${invitation.evento}"]`);
        const { status, boletos_confirmados: comfirmed_tickets } = invitation;
        if ($event && status === 'Invitado' || $event && status === 'Invitación Enviada') {
            const tickets = parseInt(invitation.boletos);
            const confirmedTickets = parseInt(invitation.boletos_confirmados);
            const currentTickets = tickets === 0 ? confirmedTickets : tickets;
            for (let i = 1; i <= currentTickets; i++) {
                const option = document.createElement('option');
                option.value = i;
                option.innerHTML = i;
                $event.appendChild(option);
            }
            if (invitation.mensaje) {
                message = `${invitation.mensaje} `;
            }
        } else if ($event && status !== 'Invitado') {
            $event.value = comfirmed_tickets;
            $event.setAttribute('disabled', true);
            $event.innerHTML = `<option value="${comfirmed_tickets}" selected>${comfirmed_tickets}</option>`;
            if (invitation.mensaje) {
                message = `${invitation.mensaje} `;
            }
        }
    });
    rsvpLname.setAttribute('readonly', true);
    rsvpEmail.setAttribute('readonly', true);
    rsvpName.setAttribute('readonly', true);
    rsvpLname.value = data.apellido;
    rsvpEmail.value = data.email;
    rsvpName.value = data.nombre;
    if (message !== '') {
        rsvpMessage.innerHTML = message;
        rsvpMessage.setAttribute('readonly', true);
        document.getElementById('rsvp-send-button-container').style.display = 'none';
    }
    rsvpType.value = data.type;
    invitation_id.value = data.gid;
    $('#rsvp-events-container').slideDown();
    $('#rsvp-message-container').slideDown();
    $('#rsvp-send-button-container').slideDown();
    button.style.display = 'none';
};
const setEventsInContainer = (events) => {
    const $eventsContainer = document.getElementById('rsvpEvents');
    const $eventTemplate = document.getElementById('event_template');
    //console.log(events)
    events.forEach((event) => {
        const $event = $eventTemplate.cloneNode(true);
        $event.setAttribute('data-id', event.id);
        $event.querySelector('label').innerHTML = event.nombre_del_evento;
        $event.querySelector('select').setAttribute('name', event.nombre_del_evento);
        $event.querySelector('select').setAttribute('metaobjectid', event.id);
        $eventsContainer.appendChild($event);
    });
    $eventTemplate.remove();
};